import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { useImpersonationPath } from '@/hooks/useImpersonationPath'
import { UserRole } from '@/types'

interface ProtectedRouteProps {
  children: React.ReactNode
  requiredRole?: UserRole
  requireAdmin?: boolean
  /** User role must be one of these. */
  requiredRoles?: UserRole[]
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredRole,
  requireAdmin = false,
  requiredRoles,
}) => {
  const { isAuthenticated, isLoading, hasRole, isAdmin, hasAnyRole } = useAuth()
  const toPath = useImpersonationPath()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">Chargement...</div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to={toPath('/')} replace />
  }

  if (requiredRole && !hasRole(requiredRole) && !isAdmin) {
    return <Navigate to={toPath('/')} replace />
  }

  if (requiredRoles?.length && !hasAnyRole(requiredRoles)) {
    return <Navigate to={toPath('/')} replace />
  }

  return <>{children}</>
}
